import React, { useEffect } from 'react';
import { getToken, onMessage } from "firebase/messaging";
import { ConfigProvider } from 'antd';
import { useDispatch } from "react-redux";

import { Toaster, toast } from 'react-hot-toast';
import { theme } from './shared/theme';
import RootRouter from './router';
import { messaging } from 'shared/utils/firebase.config';
import Message from 'shared/utils/message';
import { useSelector } from 'react-redux';
// import { connectSocket } from 'shared/service/socket';
import { setCurrentUser } from 'shared/store/chatUserSlice';
import { accountAPI } from 'pages/account/account.service';
import { ErrorBoundary } from 'pages/error/errorPage';
// import UpgradeNow from 'pages/error/upgradenow';
// import { useParams } from 'react-router';
// import FloatingWindow from 'shared/chat/floatingChatWindow';
// import DndContext from 'pages/invoices/templete/dndForm/dndContext';

const App = () => {
  const dispatch = useDispatch();
  // const {roomId}  = useParams();
  const userById = useSelector(state => state?.userById);
  let userDetails = userById['data'];

  useEffect(() => {
    const userId = userDetails?.userId;
    dispatch(setCurrentUser({ userId, status: "online" }));
    // connectSocket(userId, dispatch, roomId, userId);
  }, [userDetails]);

  useEffect(() => {
    requestPermission();

    const unsubscribe = onMessage(messaging, (payload) => {
      toast(<Message notification={payload.notification} />);
    });

    return unsubscribe;
  }, []);

  const requestPermission = async() => {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      try {
        const token = await getToken(messaging, {
          vapidKey: process.env.REACT_APP_FIREBASE_VAPID_KEY
        });
        let data = {
          deviceType: 'web',
          token: token
        };
        accountAPI.updateFCMToken(data).then(
          (data) => {
          },
          (err) => {
          }
        );

      } catch (error) {
        console.error('Token error:', error);
      }
    }
  };

  return (
    <ConfigProvider theme={theme}>
      <ErrorBoundary>
        <RootRouter />
      </ErrorBoundary>
      <Toaster
        position="top-right"
        reverseOrder={false}
        gutter={8}
        toastOptions={{
          className: '',
          duration: 5000,
          style: {
            background: '#000',
            color: '#fff',
            borderRadius: '.4rem',
            boxShadow: `var(--card-4)`,
            fontSize: '1.4rem'
          },
          success: {
            duration: 3000,
            theme: {
              primary: 'green',
              secondary: 'black'
            }
          }
        }}
      />
      {/* <DndContext>
        <FloatingWindow />
      </DndContext> */}
      {/* <div className="paymnetPage">
        <UpgradeNow />
      </div> */}
    </ConfigProvider>
  );
};

export default App;
